import { useCallback, useContext } from "react";

import DatepickerContext from "../contexts/DatepickerContext";
import PrimaryButton from "./PrimaryButton";
import SecondaryButton from "./SecondaryButton";

const Footer = () => {
  // Contexts
  const {
    hideDatepicker,
    cancelDatepicker,
    period,
    changeDatepickerValue,
    configs,
    classNames,
    input,
  } = useContext(DatepickerContext);

  // Functions
  const getClassName = useCallback(() => {
    if (
      typeof classNames !== "undefined" &&
      typeof classNames?.footer === "function"
    ) {
      return classNames.footer();
    }

    return "flex items-center justify-end pb-2.5 pt-3 border-t border-gray-300 dark:border-gray-700";
  }, [classNames]);

  return (
    <div className={getClassName()}>
      <div className="flex w-full items-center justify-center space-x-3 md:w-auto">
        <SecondaryButton
          onClick={() => {
            cancelDatepicker();
          }}
        >
          <>{configs?.footer?.cancel ? configs.footer.cancel : "Cancel"}</>
        </SecondaryButton>

        <PrimaryButton
          onClick={() => {
            if (period.start && period.end) {
              changeDatepickerValue(
                {
                  startDate: period.start,
                  endDate: period.end,
                },
                input,
              );
              hideDatepicker();
            }
          }}
          disabled={!(period.start && period.end)}
        >
          <>{configs?.footer?.apply ? configs.footer.apply : "Apply"}</>
        </PrimaryButton>
      </div>
    </div>
  );
};

export default Footer;
